import { RecentClientSearchStoreContextWrapper } from '@common/contexts';
import { ClientRecentResultsStore } from '@common/stores';
import React from 'react';
export const useRecentClientSearch = () => React.useContext<ClientRecentResultsStore>(RecentClientSearchStoreContextWrapper.get());
